import { render, staticRenderFns } from "./CustomerWorks.vue?vue&type=template&id=78bf9dd0&scoped=true&"
import script from "./CustomerWorks.vue?vue&type=script&lang=js&"
export * from "./CustomerWorks.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWorks.vue?vue&type=style&index=0&id=78bf9dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf9dd0",
  null
  
)

export default component.exports